import { enhancedApi } from '.'

// eslint-disable-next-line import/prefer-default-export
export const { useCreateSiteEnergyConfigurationMutation } = enhancedApi.enhanceEndpoints({
  endpoints: {
    createSiteEnergyConfiguration: {
      invalidatesTags: ['Site Feature Configurations', 'Site Energy Configurations', 'Node Energy Configurations']
    },
    updateSiteReservationConfiguration: {
      invalidatesTags: ['Site Reservations Configuration', 'Reservations']
    },
    createSiteReservationConfiguration: {
      invalidatesTags: ['Site Reservations Configuration', 'Reservations']
    }
  }
})
